import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../../style/header.css";
import "../../style/generic.css";
import "../../style/popup.css";
import logo from "../../images/logo.png";
import homeIcon from "../../images/home-icon.png";
import categoryIcon from "../../images/category-icon.png";
import searchIcon from "../../images/search-icon.png";
import arrowIcon from "../../images/weui_arrow-filled.png";
import closeMenu from "../../images/mingcute_close-fill.png";
import frecciaSelect from "../../images/weui_arrow-filled.png";
import axios from "axios";
import * as Constanti from "../../Utils/constants.js";
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import CardTwo from "../cards/cardTwo.js";
import { withRouter } from "../hooks/navigation.js";

// ------------------------------------------------------
// 🔥 DISATTIVA TUTTE LE ANIMAZIONI SU MOBILE
// ------------------------------------------------------
const isMobile = window.innerWidth < 768;

if (isMobile) {
  // Sovrascrivo i componenti motion con versioni "statiche"
  motion.nav = (props) => <nav {...props}>{props.children}</nav>;
  motion.div = (props) => <div {...props}>{props.children}</div>;
  motion.span = (props) => <span {...props}>{props.children}</span>;
}

class CustomHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      status: "",
      isSearch: false,
      query: "",
      videos: [],
      loading: false,
      categorieSelezionate: [],
      strCat: "Categorie",
      allVideos: [],
    };
  }

  componentDidMount() {
    document.addEventListener("scroll", () => {
      const scrolled = document.scrollingElement.scrollTop;
      this.setState({ status: scrolled >= 120 ? "navbarscroll" : "" });
    });
    this.fetchVideoPiuCercati();
  }

  togglePopup = () => this.setState((p) => ({ isOpen: !p.isOpen }));
  closePopup = () => this.setState({ isOpen: false });
  toggleSearchPopup = () => this.setState((p) => ({ isSearch: !p.isSearch }));
  closePopupSearch = () => this.setState({ isSearch: false });

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ query: value });
    if (value.length > 3) {
      this.fetchSearchVideo(value);
    }
    if (value.length == 0){
        this.fetchVideoPiuCercati();
    }
  };

  toggleCategoria = (id) => {
    this.setState((prevState) => {
      const { categorieSelezionate, allVideos } = prevState;
      let newCategorieSelezionate;
      if (id === 0) {
        newCategorieSelezionate = [];
      } else {
        if (categorieSelezionate.includes(id)) {
          newCategorieSelezionate = categorieSelezionate.filter((catId) => catId !== id);
        } else {
          newCategorieSelezionate = [...categorieSelezionate, id];
        }
      }

      const newVideos =
        newCategorieSelezionate.length > 0
          ? allVideos.filter((v) => newCategorieSelezionate.includes(v.category_video_id))
          : allVideos;

      return { categorieSelezionate: newCategorieSelezionate, videos: newVideos };
    });
  };

  async fetchVideoPiuCercati() {
    try {
      this.setState({ loading: true });
      const response = await axios.get(Constanti.url_Backend + "videoPiuCercati");
      this.setState({
        videos: response.data.data,
        allVideos: response.data.data,
        loading: false,
      });
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
    }
  }

  async fetchSearchVideo(query) {
    const { categorieSelezionate } = this.state;
    try {
      this.setState({ loading: true });
      const response = await axios.get(Constanti.url_Backend + "searchVideos", {
        params: { q: query },
      });
      let newVideos;
      if (categorieSelezionate.length > 0) {
        newVideos = response.data.data.filter((v) => categorieSelezionate.includes(v.category_video_id));
      } else {
        newVideos = response.data.data;
      }
      this.setState({ videos: newVideos, allVideos: response.data.data, loading: false });
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
    }
  }

  render() {
    const { isOpen, status, isSearch, videos, loading, query, categorieSelezionate } = this.state;
    const { categorie } = this.props;
    let categoriaCorrispondente = null;
    if (this.props.location.pathname.includes("categoria")){
     const match = this.props.location.pathname.match(/\/categoria\/([^/]+)/);
      let id = match ? match[1] : null;
     
      if (id !== null && Array.isArray(categorie)) {
        categoriaCorrispondente = categorie.find(cat => String(cat.id) === id);
      }
    }
console.log(this.props.location.pathname);
    return (
      <>
        <motion.nav className={`navbar ${status}`} initial="hidden" animate="visible">
          <div className="container">
            <motion.div className="flex vertical" variants={!isMobile ? { visible: { transition: { staggerChildren: 0.3 } } } : {}}>
              <motion.div
                className="flex horizontal padding-bottom-16 noMobile"
                variants={!isMobile ? { hidden: { opacity: 0, y: -30 }, visible: { opacity: 1, y: 0 } } : {}}
              >
                <motion.div className="padding-right-24" variants={!isMobile ? { hidden: { opacity: 0 }, visible: { opacity: 1 } } : {}}>
                  <Link to="https://www.alis.it/alis-app/" target="_blank" className="navLink">ALIS app</Link>
                </motion.div>

                <motion.div variants={!isMobile ? { hidden: { opacity: 0 }, visible: { opacity: 1 } } : {}}>
                  <Link to="https://magazine.alischannel.it/" target="_blank" className="navLink">ALIS magazine</Link>
                </motion.div>
              </motion.div>

             <motion.div
  className="noMobile"
  initial={!isMobile ? { scaleX: 0 } : false}
  animate={!isMobile ? { scaleX: 1 } : false}
  transition={{ duration: 0.7, ease: "easeInOut" }}
  style={{ height: 0.5, backgroundColor: "#FFFFFF",opacity: 0.3, transformOrigin: "left" }}
/>

              <motion.div className={"flex horizontal navContent "+ (!isMobile ? "padding-top-16":"")} initial="hidden" animate="visible">
                <motion.div className="logo-container" variants={!isMobile ? { hidden: { opacity: 0 }, visible: { opacity: 1 } } : {}}>
                  <Link to="/">
                    <img src={logo} alt="Logo" width={88} height={50} className="logoSidebar mob" />
                  </Link>
                </motion.div>

                <motion.div className="right-link align-center flex horizontal gap-40">
                  {/* HOME */}
                  <motion.div className="flex horizontal align-center gap-8 noMobile">
                    <img src={homeIcon} width={24} height={24} alt="" className="logoSidebar" />
                    <Link to="/">Home</Link>
                  </motion.div>

                  {/* CATEGORIE */}
                  <motion.div className="flex horizontal align-center gap-8 noMobile cursor-pointer" onClick={this.togglePopup}>
                    <img src={categoryIcon} width={24} height={24} alt="" className="logoSidebar cursor-pointer" />
                    <div className="cursor-pointer">Categorie</div>
                    <img src={arrowIcon} width={10} height={5} alt="" className="logoSidebar cursor-pointer" />
                  </motion.div>
                  {categoriaCorrispondente && isMobile &&
                    
                  <div className="category-select-mobile horizontal align-center gap-8 cursor-pointer" onClick={this.togglePopup}>
                    <span className="catDescriptionMobile">{categoriaCorrispondente.description}</span>
                   <img src={arrowIcon} width={10} height={5} alt="" className="logoSidebar cursor-pointer" />
                  </div>
                  }
                  {/* CERCA */}
                  <motion.div className="flex horizontal gap-8">
                    <div className="iconBackground align-center horizontal flex justify-center" onClick={this.toggleSearchPopup}>
                      <img src={searchIcon} width={24} height={24} alt="cerca" className="logoSidebar cursor-pointer" />
                    </div>
                  </motion.div>
                </motion.div>
              </motion.div>
            </motion.div>
          </div>

          {/* POPUP CATEGORIE & SEARCH */}
          <AnimatePresence>
            {isOpen && (
              <motion.div className="fullscreen-popup" initial={{ y: "-100%" }} animate={{ y: 0 }} exit={{ y: "-100%" }}>
                <div className="close-button" onClick={this.closePopup}>
                  <img src={closeMenu} alt="chiudi" width={36} height={36} />
                </div>

                <div className="popup-content">
                  {categorie?.map((el) => (
                    <Link className="block-link" key={el.id} to={`/categoria/${el.id}`} onClick={this.closePopup}>
                      <motion.span className="link-menu">{el.description}</motion.span>
                    </Link>
                  ))}
                </div>
              </motion.div>
            )}

            {isSearch && (
              <motion.div className="fullscreen-popup" initial={{ y: "-100%" }} animate={{ y: 0 }} exit={{ y: "-100%" }}>
                <div className="close-button" onClick={this.closePopupSearch}>
                  <img src={closeMenu} alt="chiudi" width={36} height={36} />
                </div>

                <div className="container flex vertical searchMobile">
                  <div className="search-bar-container">
                    <span className="search-icon">
                      <img src={searchIcon} width={22} height={22} alt="search" />
                    </span>
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Cerca"
                      value={query}
                      onChange={this.handleChange}
                    />
                  </div>

                  {query.length > 0 && (
                    <div className="categorie-list flex wrap padding-top-32">
                      <div
                        className={`bulletCat ${categorieSelezionate.length === 0 ? "category-selected" : ""}`}
                        onClick={() => this.toggleCategoria(0)}
                      >
                        Tutti
                      </div>

                      {categorie?.map((cat) => (
                        <div
                          key={cat.id}
                          className={`bulletCat ${categorieSelezionate.includes(cat.id) ? "category-selected" : ""}`}
                          onClick={() => this.toggleCategoria(cat.id)}
                        >
                          {cat.description}
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="align-left padding-top-40">{query.length > 3 ? "Risultati" : "I più cercati"}</div>

                  <div className="grid padding-top-16 margin-bottom-32">
                    {loading && <p>Caricamento...</p>}
                    {!loading && videos?.length === 0 &&
                      <p>Non ci sono video per il testo cercato.</p>
                    }
                    {!loading &&
                      videos.map((video) => (
                        <div className="contenitoreCard" key={video.id}>
                          <Link to={`/video/${video.id}`} onClick={this.closePopupSearch}>
                            <CardTwo thumbnail={video.thumbnail} title={video.title} data={video.created_at} />
                          </Link>
                        </div>
                      ))}
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.nav>
      </>
    );
  }
}

export default withRouter(CustomHeader);
